var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"west-slide-left-navigation"},[_c('nuttrema-menu-list',[_c('nuttrema-menu-list-item',{attrs:{"theme":"brand-image"}},[_c('span',[_c('img',{attrs:{"src":require("assets/images/dc-logo-small-white.svg"),"alt":"Diet Creator :: Logo"}})])]),_vm._v(" "),_c('nuttrema-menu-list-item',{attrs:{"style-props":{ 'justify-content': 'center' }}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33a1c7b6","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/west-slide-component/west-slide-left-navigation.vue
// module id = 3007
// module chunks = 0